import React from "react";
import { GridIcon } from "@aureskonnect/react-ui";

import {
    ID_APPLICATIONS,
    ID_KIOSK,
    ID_KIOSK_TEMPLATE,
    ID_KIOSK_PERIPHERAL,
    ID_CC,
    ID_CC_SETUP,
    // ID_KDS,
    // ID_KDS_APP_SETUP,
    // ID_KDS_PERIPHERAL,
    ID_POS,
    ID_POS_TEMPLATE,
    ID_POS_PERIPHERAL,
    // ID_ORB,
    // ID_ORB_PROJECT_SETUP,
    // ID_ORB_SETUP,
} from "../../../constants/menu";
import { TFn, MenuItem, ICON_SIZE } from "./types";

export function buildApplications(t: TFn, isDefault: boolean): MenuItem {
    return {
        icon: <GridIcon {...ICON_SIZE} />,
        link: "/applications",
        menuItem: t("Applications"),
        id: ID_APPLICATIONS,
        customClassName: "sid_drp_application",
        subMenu: [
            {
                link: "/kiosk",
                menuItem: t("KIOSK"),
                id: ID_KIOSK,
                customClassName: "sid_drp_kiosk",
                subMenu: [
                    {
                        link: "/project",
                        menuItem: t("Template Setup"),
                        customClassName: "sid_btn_configureTemplate",
                        id: ID_KIOSK_TEMPLATE,
                    },
                    {
                        link: "/kiosk-peripheral-setting",
                        menuItem: t("Peripheral setting"),
                        customClassName: "sid_btn_peripheralSetting",
                        id: ID_KIOSK_PERIPHERAL,
                    },
                ],
            },
            {
                link: "/c&c",
                menuItem: t("C&C"),
                customClassName: "sid_btn_appClickAndCollect",
                id: ID_CC,
                subMenu: [
                    {
                        id: ID_CC_SETUP,
                        link: isDefault ? "/Configuration" : "#",
                        menuItem: t("C&C Setup"),
                        customClassName: "sid_btn_siteClickAndCollect",
                    },
                ],
            },
            // {
            //     link: "/kds",
            //     menuItem: t("KDS"),
            //     id: ID_KDS,
            //     customClassName: "sid_btn_kds",
            //     subMenu: [
            //         {
            //             id: ID_KDS_APP_SETUP,
            //             link: "/kds-project-setting",
            //             menuItem: t("Application Setup"),
            //             customClassName: "sid_btn_configureTemplate",
            //         },
            //         {
            //             id: ID_KDS_PERIPHERAL,
            //             link: "/kds-peripheral-setting",
            //             menuItem: t("Peripheral setting"),
            //             customClassName: isDefault
            //                 ? "sid_btn_siteClickAndCollect"
            //                 : "sid_btn_peripheralSetting",
            //         },
            //     ],
            // },
            {
                link: "/pos",
                id: ID_POS,
                menuItem: t("POS"),
                customClassName: "sid_btn_pos",
                subMenu: [
                    {
                        id: ID_POS_TEMPLATE,
                        link: "/pos-project-setting",
                        menuItem: t("Template Setup"),
                        customClassName: "sid_btn_configureTemplate",
                    },
                    {
                        id: ID_POS_PERIPHERAL,
                        link: "/pos-peripheral-setting",
                        menuItem: t("Peripheral setting"),
                        customClassName: "sid_btn_peripheralSetting",
                    },
                ],
            },
            // {
            //     link: "/orb",
            //     menuItem: t("ORB"),
            //     customClassName: "sid_btn_orb",
            //     id: ID_ORB,
            //     subMenu: [
            //         {
            //             id: ID_ORB_PROJECT_SETUP,
            //             link: "/orb-project-setup",
            //             menuItem: t("Project setup"),
            //             customClassName: "sid_btn_configureProjectORB",
            //         },
            //         {
            //             id: ID_ORB_SETUP,
            //             link: "/orb-setup",
            //             menuItem: t("ORB Setup"),
            //             customClassName: "sid_btn_configureORB",
            //         },
            //     ],
            // },
        ],
    };
}
